import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenMapComponent } from "./components/loren-map/loren-map.component";
import { LorenMapRoutingModule } from "./loren-map-routing.module";
import { LeafletModule } from "@bluehalo/ngx-leaflet";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";

import { LeafletMarkerClusterModule } from "@bluehalo/ngx-leaflet-markercluster";
import { LeafletDrawModule } from "@bluehalo/ngx-leaflet-draw";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenDialogModule } from "../../shared/modules/loren-dialog/loren-dialog.module";
import { LorenExpansionPanelModule } from "../../shared/modules/loren-expansion-panel/loren-expansion-panel.module";
import { LorenAllAssetResolver } from "../loren-assets/resolvers/loren-asset-all.resolver";
import { LorenCardModule } from "../../shared/modules/loren-card/loren-card.module";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";
import { LorenImagePipe } from "../../shared/pipes/loren-image/pipes/loren-image.pipe";
import { LorenLayersSelectionDialogModule } from "../../shared/modules/loren-layers-selection-dialog/loren-layers-selection-dialog.module";
import { LorenLayerSelectionModule } from "../../shared/modules/loren-layer-selection/loren-layer-selection.module";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";
import { LorenLocationFilterModule } from "../../shared/modules/loren-location-filter/loren-location-filter.module";
import { LorenDateModule } from "../../shared/pipes/loren-date/loren-date.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
import { LorenMapDetailsPopupComponent } from "./components/loren-map-details-popup/loren-map-details-popup.component";
import { LorenMapDetailsSidepanelComponent } from "./components/loren-map-details-sidepanel/loren-map-details-sidepanel.component";
import { MapPageComponent } from "../maps/pages/map-page.component";

@NgModule({
  declarations: [LorenMapComponent, MapPageComponent],
  providers: [LorenAllAssetResolver, LorenImagePipe],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatTooltipModule,
    LeafletModule,
    LeafletDrawModule,
    LeafletMarkerClusterModule,
    TranslocoModule,
    LorenMapRoutingModule,
    LorenDialogModule,
    LorenExpansionPanelModule,
    LorenCardModule,
    LorenImageModule,
    LorenLayersSelectionDialogModule,
    LorenSharedDirectivesModule,
    LorenLayerSelectionModule,
    LorenLocationFilterModule,
    LorenDateModule,
    LorenPageContentComponent,
    LorenMapDetailsPopupComponent,
    LorenMapDetailsSidepanelComponent,
  ],
  exports: [LorenMapComponent],
})
export class LorenMapModule {}
